import { render } from "./ErrorModal.vue?vue&type=template&id=06972caf&scoped=true"
const script = {}

import "./ErrorModal.vue?vue&type=style&index=0&id=06972caf&lang=scss&scoped=true"

import exportComponent from "/home/prof1/projects/intercom_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06972caf"]])

export default __exports__